<template>
  <div>
    <b-button @click="handleToggleBusyClick">
      Toggle Busy State
    </b-button>
    <b-table
      :fields="fields"
      :items="items"
      :busy="isBusy"
      class="mt-3"
      outlined
    >
      <!-- A virtual column -->
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isBusy: false,
      fields: [
        // A virtual column that doesn't exist in items
        "index",
        // A column that needs custom formatting
        { key: "name", label: "Name" },
        // A regular column
        "phone"
      ],
      items: [
        { name: "Pruitt Health- Advantage", phone: 3106214068 },
        { name: "Savalas Colbert", phone: 3106214068 },
        { name: "Insurance Company", phone: 3106214068 },
        { name: "Metformin", phone: 3106214068 }
      ]
    };
  },
  methods: {
    handleToggleBusyClick() {
      this.isBusy = !this.isBusy;
    }
  }
};
</script>

<style lang="scss" scoped></style>
